module.exports = __webpack_public_path__ + "019f7c1a31e162169e232b7643f3659b.glb";